/* global gdAlertify */
import React, { useState, useEffect } from "react";
import axiosInstance from "../config/axiosConfig";
import GdTable from "./components/GdTable"; // Asegúrate de ajustar la ruta
import BuscarUsuario from "./components/BuscarUsuario";
import { formatDate } from "../utils/utils";

const ModalAsignacionSector = ({ isOpen, onClose, sectores, onSave }) => {
    const [asignaciones, setAsignaciones] = useState({});

    // Inicializar estado cuando se abre el modal
    useEffect(() => {
        if (isOpen && sectores.length > 0) {
            const initial = {};
            sectores.forEach(s => initial[s.id] = null);
            setAsignaciones(initial);
        }
    }, [isOpen, sectores]);

    const handleChange = (sectorId, usuario) => {
        setAsignaciones(prev => ({
            ...prev,
            [sectorId]: usuario ? usuario.id : null
        }));
    };

    const handleGuardar = () => {
        // Validar que se hayan seleccionado usuarios (opcional, depende de reglas de negocio)
        // Aquí permitimos guardar, asumiendo que el backend maneja si faltan sectores (o se dejan sin asignar)
        const payload = Object.entries(asignaciones).map(([sectorId, usuarioId]) => ({
            sectorId: parseInt(sectorId),
            usuarioId,
        })).filter(item => item.usuarioId !== null);

        if (payload.length === 0) {
            gdAlertify.notify("Debes asignar al menos un usuario.", "error");
            return;
        }

        onSave(payload);
    };

    if (!isOpen) return null;

    return (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Asignar Sectores (Nueva Planificación)</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <p className="text-muted mb-4">
                            Busque el usuario responsable para cada sector. Esta acción cerrará la planificación anterior y activará la nueva a partir de hoy.
                        </p>
                        <form>
                            {sectores.map(sector => (
                                <div className="mb-3 row" key={sector.id}>
                                    <label className="col-sm-3 col-form-label fw-bold mt-4">{sector.nombre}</label>
                                    <div className="col-sm-9">
                                        <BuscarUsuario
                                            onSelect={(usuario) => handleChange(sector.id, usuario)}
                                            onClear={() => handleChange(sector.id, null)}
                                        />
                                    </div>
                                </div>
                            ))}
                        </form>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
                        <button type="button" className="btn btn-primary" onClick={handleGuardar}>Guardar Planificación</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const PlanificacionSector = () => {
    const [historial, setHistorial] = useState([]);
    const [sectores, setSectores] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);

    // Cargar datos iniciales
    useEffect(() => {
        fetchHistorial();
        fetchSectores();
    }, []);

    const fetchHistorial = async () => {
        gdAlertify.showLoader();
        try {
            const response = await axiosInstance.get("/planificacion/lista");
            if (response.data && response.data.data) {
                setHistorial(response.data.data);
            }
        } catch (error) {
            console.error(error);
            // gdAlertify.notify("Error cargando historial", "error");
        } finally {
            gdAlertify.hideLoader();
        }
    };

    const fetchSectores = async () => {
        try {
            const response = await axiosInstance.get("/planificacion/sectores");
            if (response.data && response.data.data) {
                setSectores(response.data.data);
            }
        } catch (error) {
            console.error(error);
        }
    };



    const handleSavePlanificacion = async (payload) => {
        setIsModalOpen(false); // Cerrar modal inmediatamente
        gdAlertify.showLoader();
        try {
            const response = await axiosInstance.post("/planificacion/guardar", { asignaciones: payload });
            if (!response.data.error) {
                gdAlertify.notify("Planificación guardada correctamente.", "success");
                fetchHistorial(); // Recargar tabla
            } else {
                gdAlertify.notify(response.data.message || "Error al guardar.", "error");
            }
        } catch (error) {
            console.error(error);
            gdAlertify.notify("Error de conexión.", "error");
        } finally {
            gdAlertify.hideLoader();
        }
    };

    const columns = [
        { name: "id", title: "#", width: 50 },
        { name: "fecha_inicio", title: "Fecha Inicio", render: (row) => formatDate(row.fecha_inicio), width: 120 },
        { name: "fecha_fin", title: "Fecha Fin", render: (row) => row.fecha_fin ? formatDate(row.fecha_fin) : <span className="badge bg-success">Actual</span>, width: 120 },
        { name: "nombre_sector", title: "Sector", width: 150 },
        { name: "nombre_usuario", title: "Usuario Asignado" },
        { name: "asignado_por_nombre", title: "Asignado Por", width: 200 },
    ];

    return (
        <div className="container-fluid mt-5">
            <div className="card shadow-sm">
                <div className="card-header bg-white d-flex justify-content-between align-items-center py-3">
                    <h4 className="mb-0 text-primary"><i className="bi bi-map me-2"></i>Planificación de Sectores</h4>
                    <button className="btn btn-primary" onClick={() => setIsModalOpen(true)}>
                        <i className="bi bi-plus-lg me-2"></i>Nueva Planificación
                    </button>
                </div>
                <div className="card-body">
                    <GdTable
                        columns={columns}
                        data={historial}
                        defaultItemsPerPage={20}
                        itemsPerPageOptions={[10, 20, 50]}
                        initialSort={[0, "desc"]}
                    />
                </div>
            </div>

            <ModalAsignacionSector
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                sectores={sectores}
                onSave={handleSavePlanificacion}
            />
        </div>
    );
};

export default PlanificacionSector;
